import { createMapStore } from "@fortex/map";
import type { Labels, MapCoreApi, MapStore, Toast } from "@fortex/map";

export type ShellCore = MapCoreApi & { setLabels(labels: Labels): void };

export function createShellCore(initialLabels: Labels): ShellCore {
  const store: MapStore = createMapStore({ ready: true });
  let labels = initialLabels;

  const shell = {
    store,
    get labels() {
      return labels;
    },
    setLabels: (next: Labels) => {
      labels = next;
    }
  };

  return shell as unknown as ShellCore;
}

export function pushToast(core: Pick<MapCoreApi, "store">, severity: Toast["severity"], text: string): number {
  return core.store.getState().pushToast({ severity, text });
}
